import type { Collection } from '@gonfalon/immutable-shim/immutableShim';
import { isImmutable } from '@gonfalon/immutable-shim/immutableShim';
import { couldBeBoolean } from '@gonfalon/types/couldBeBoolean';
import { couldBeNumber } from '@gonfalon/types/couldBeNumber';
import { isJSONString } from '@gonfalon/types/isJSONString';
import { isJSONValue } from '@gonfalon/types/isJSONValue';
import { isBoolean, isNumber, isString } from 'lodash';

// oxlint-disable-next-line typescript/no-explicit-any
export const couldBeJSONValue = (v?: any) => isJSONString(v) || isJSONValue(v);

// oxlint-disable-next-line typescript/no-explicit-any
export const areAllBooleans = (values: any[]) => !!values.length && values.every(isBoolean);

// oxlint-disable-next-line typescript/no-explicit-any
export const areAllNumbers = (values: any[]) => !!values.length && values.every(isNumber);

// oxlint-disable-next-line typescript/no-explicit-any
export const areAllStrings = (values: any[]) => !!values.length && values.every(isString);

// oxlint-disable-next-line typescript/no-explicit-any
export const areAllJSON = (values: any[]) => !!values.length && values.every(isJSONValue);

// oxlint-disable-next-line typescript/no-explicit-any
export const couldAllBeNumbers = (values: any[] | Collection<any, any>) =>
  isImmutable(values) ? values.every(couldBeNumber) : values.every(couldBeNumber);

// oxlint-disable-next-line typescript/no-explicit-any
export const couldAllBeBooleans = (values: any[] | Collection<any, any>) =>
  isImmutable(values) ? values.every(couldBeBoolean) : values.every(couldBeBoolean);

// oxlint-disable-next-line typescript/no-explicit-any
export const couldAllBeJSON = (values: any[] | Collection<any, any>) =>
  isImmutable(values) ? values.every(couldBeJSONValue) : values.every(couldBeJSONValue);

// oxlint-disable-next-line typescript/no-explicit-any
export const getAlternateType = (v: any) => {
  const type = typeof v;
  if (type !== 'string') {
    return 'string';
  }
  if (couldBeNumber(v)) {
    return 'number';
  }
  if (couldBeBoolean(v)) {
    return 'boolean';
  }
};
